var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as d3 from 'd3';
import { ChartLine } from './chart-line';
var ChartLineMiddled = /** @class */ (function (_super) {
    __extends(ChartLineMiddled, _super);
    function ChartLineMiddled(ctrlr, yParameter, colour) {
        return _super.call(this, ctrlr, yParameter, colour) || this;
    }
    ChartLineMiddled.prototype.draw = function (data) {
        this.data = data;
        _super.prototype.draw.call(this, data);
    };
    ChartLineMiddled.prototype.lineMaker = function () {
        var _this = this;
        var yParameter = this.ctrlr.parameters[this.yParameter] != undefined ? this.ctrlr.parameters[this.yParameter] : this.yParameter;
        var middle = function (d, i) {
            if (i > 3 && i < _this.data.slice.length) {
                var v = (_this.data.slice[i - 3][yParameter] + _this.data.slice[i - 2][yParameter] + _this.data.slice[i - 1][yParameter] + _this.data.slice[i][yParameter]) / 4;
                return _this.ctrlr.scales.y.scale(v);
            }
            else {
                return _this.ctrlr.scales.y.scale(d[yParameter]);
            }
        };
        return d3.line()
            .x(function (d) {
            var k = _this.ctrlr.scales.x.scale(d[_this.ctrlr.parameters.x] + .5);
            return k;
        })
            .y(function (d, i) {
            var m = middle(d, i);
            return m;
        })
            .curve(d3.curveBasis);
    };
    ChartLineMiddled.prototype.redraw = function () {
        _super.prototype.redraw.call(this);
        this.line
            .attr("stroke", function (d) { return "black"; });
    };
    return ChartLineMiddled;
}(ChartLine));
export default ChartLineMiddled;
